export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-muted/40">
      <div className="mx-auto max-w-xl px-4 py-3">
        <div className="text-center text-xs text-muted-foreground">
          <p>&copy; {currentYear} Squadron Play. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
